import update from 'immutability-helper';

import { mapOffices } from 'utils/set-takeaway-offices';
import { DELIVERY_TYPE_TAKEAWAY } from 'store/constants';

import {
  SET_DELIVERY_TAKEAWAY_SEARCH_QUERY,
  SET_DELIVERY_TAKEAWAY_ACTIVE_BUTTON,
  SET_DELIVERY_TAKEAWAY_SORT_DIRECTION,
  SET_DELIVERY_TAKEAWAY_POINTS_TO_SHOW,
  SET_DELIVERY_ACTIVE_POINT,
  SET_CATALOG_PRODUCT_OFFICES,
  UNSET_CATALOG_PRODUCT_OFFICES,
  DELIVERY_TAKEAWAY_OPEN,
  DELIVERY_TAKEAWAY_VIEW,
  DELIVERY_TAKEAWAY_SUCCESS,
  DELIVERY_TAKEAWAY_LOADING,
  REQUEST_CATALOG_PRODUCT_OFFICES_ERROR,
  DELIVERY_TAKEAWAY_POINTS_SHOW_COUNT,
  CATALOG_TAKEAWAY_VIEW_LIST,
  SET_DELIVERY_POINTS_VIEW,
  SET_CATALOG_PRODUCT_HOVERED_ID,
  SET_CATALOG_PRODUCT_HOVERED_TITLE,
  CATALOG_PRODUCT_DESCRIPTION_PLATE,
  REQUEST_AGREEMENT_CONTENT_SUCCESS,
  REQUEST_PROPS_CONTENT_SUCCESS,
  HIDE_DELIVERY_TAKEAWAY_POINTS_TO_SHOW,
  SET_INITIAL_CATALOG_DELIVERY_OFFICES,
  SET_DELIVERY_TAKEAWAY_FILTERS,
  SET_DELIVERY_TAKEAWAY_FILTER_OPTION,
} from './constants';

const initialState = {
  currentSection: null,
  currentDeliverySection: DELIVERY_TYPE_TAKEAWAY,
  sortWidgetState: {
    activeButton: 'metro',
    currentView: 'list',
    reverse: false,
    usingButtons: [
      {
        slug: 'address',
        reverseMode: true,
        reverseText: 'Адресу Я-А',
        buttonText: 'Адресу А-Я',
      },
      {
        slug: 'metro',
        reverseMode: true,
        reverseText: 'Метро Я-А',
        buttonText: 'Метро А-Я',
      },
    ],
  },
  officesToShow: DELIVERY_TAKEAWAY_POINTS_SHOW_COUNT,
  hoveredProductId: null,
  hoveredProductTitle: '',
  productDescriptionPlate: CATALOG_PRODUCT_DESCRIPTION_PLATE,
  offices: [],
  deliveryTakeawaySearchQuery: '',
  deliveryPickupOpenState: false,
  deliveryPickupPoint: null,
  deliveryPickupViewState: 'form',
  deliveryPointsViewForm: CATALOG_TAKEAWAY_VIEW_LIST,
  deliveryPickupSuccess: {
    name: '',
    phone: '',
    orderId: '',
    price: '',
    title: '',
    pointAddress: '',
    pointOpening: '',
    hasESim: false,
  },
  deliveryPickupLoading: false,
  deliveryPickupErrorDetails: {
    headline: 'Произошла ошибка',
    message: 'Попробуйте позднее.',
  },
  pickupBuy: {
    headline: 'На кого оформить заказ?',
    description: '',
    buttonText: 'Подтвердить заказ',
    agreementMessage: '',
    agreementContent: '',
    propsContent: '',
    agreementDataUrl: '/shop/sitetext/?key=SHOP_CONTENT_PICKUP_BUY_AGREEMENT',
    propsDataUrl: '/shop/sitetext/?key=SHOP_CONTENT_PICKUP_BUY_PROPS',
  },
};

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_DELIVERY_TAKEAWAY_SEARCH_QUERY: {
      const { value } = action;
      return {
        ...state,
        deliveryTakeawaySearchQuery: value,
      };
    }
    case SET_CATALOG_PRODUCT_OFFICES:
    case UNSET_CATALOG_PRODUCT_OFFICES: {
      const { offices: unmappedOffices } = action;
      return {
        ...state,
        offices: mapOffices(unmappedOffices),
      };
    }
    case SET_CATALOG_PRODUCT_HOVERED_ID: {
      const { id } = action;
      return {
        ...state,
        hoveredProductId: id,
      };
    }
    case SET_CATALOG_PRODUCT_HOVERED_TITLE: {
      const { title } = action;
      const { productDescriptionPlate } = state;
      return update(state, {
        hoveredProductTitle: { $set: title },
        pickupBuy: {
          description: { $set: `${title} ${productDescriptionPlate}` },
        },
      });
    }
    case SET_DELIVERY_POINTS_VIEW: {
      const { slug } = action;
      return {
        ...state,
        deliveryPointsViewForm: slug,
      };
    }
    case SET_DELIVERY_ACTIVE_POINT: {
      return {
        ...state,
        deliveryPickupPoint: action.payload,
      };
    }
    case DELIVERY_TAKEAWAY_OPEN: {
      return {
        ...state,
        deliveryPickupOpenState: action.payload,
      };
    }
    case DELIVERY_TAKEAWAY_VIEW: {
      return {
        ...state,
        deliveryPickupViewState: action.payload,
      };
    }
    case DELIVERY_TAKEAWAY_SUCCESS: {
      return {
        ...state,
        deliveryPickupSuccess: action.payload,
      };
    }
    case DELIVERY_TAKEAWAY_LOADING: {
      return {
        ...state,
        deliveryPickupLoading: action.payload,
      };
    }
    case REQUEST_AGREEMENT_CONTENT_SUCCESS: {
      return update(state, {
        pickupBuy: {
          agreementContent: { $set: action.payload },
        },
      });
    }
    case REQUEST_PROPS_CONTENT_SUCCESS: {
      return update(state, {
        pickupBuy: {
          propsContent: { $set: action.payload },
        },
      });
    }
    case REQUEST_CATALOG_PRODUCT_OFFICES_ERROR: {
      const { message } = action;
      return {
        ...state,
        deliveryPickupErrorDetails: {
          headline: message.Subject,
          message: message.Message,
        },
      };
    }
    case SET_DELIVERY_TAKEAWAY_ACTIVE_BUTTON: {
      const { slug } = action;
      return update(state, {
        sortWidgetState: {
          activeButton: { $set: slug },
        },
      });
    }
    case SET_DELIVERY_TAKEAWAY_SORT_DIRECTION: {
      const { reverse } = action;
      return update(state, {
        sortWidgetState: {
          reverse: { $set: !reverse },
        },
      });
    }
    case SET_DELIVERY_TAKEAWAY_POINTS_TO_SHOW: {
      const { pointsCount } = action;
      return update(state, {
        officesToShow: { $set: pointsCount },
      });
    }
    case HIDE_DELIVERY_TAKEAWAY_POINTS_TO_SHOW: {
      const { pointsCount } = action;
      return update(state, {
        officesToShow: { $set: pointsCount },
      });
    }
    case SET_INITIAL_CATALOG_DELIVERY_OFFICES: {
      const { allOffices } = action;
      return {
        ...state,
        allOffices,
      };
    }
    case SET_DELIVERY_TAKEAWAY_FILTERS: {
      const { filters } = action;
      return {
        ...state,
        filters,
      };
    }
    case SET_DELIVERY_TAKEAWAY_FILTER_OPTION: {
      const { option } = action;
      return {
        ...state,
        filters: state.filters.map((filter) =>
          filter.slug === option.slug ? { ...filter, ...option } : filter,
        ),
      };
    }
    default:
      return state;
  }
}
